import API from '../AxiosInstance';
import { chunkArray, needsChunking, BackendLimits } from '@/components/utils/request-chunking';

export default {
  downloadThings: async function(payload) {
    const { nodeids = [], podids = [], assetids = [], excludeAssets } = payload;

    const needsNodeChunking = needsChunking(nodeids, BackendLimits.MAX_NODES_PER_DOWNLOAD);
    const needsPodChunking = needsChunking(podids, BackendLimits.MAX_PODS_PER_DOWNLOAD);
    const needsAssetChunking = needsChunking(assetids, BackendLimits.MAX_ASSETS_PER_DOWNLOAD);

    // If no chunking needed, single request
    if (!needsNodeChunking && !needsPodChunking && !needsAssetChunking) {
      const response = await API.post('download', payload);
      return response.data || response;
    }

    // Build chunked payloads
    const nodeChunks = chunkArray(nodeids, BackendLimits.MAX_NODES_PER_DOWNLOAD);
    const podChunks = chunkArray(podids, BackendLimits.MAX_PODS_PER_DOWNLOAD);
    const assetChunks = chunkArray(assetids, BackendLimits.MAX_ASSETS_PER_DOWNLOAD);

    const maxChunks = Math.max(nodeChunks.length, podChunks.length, assetChunks.length);
    const results = [];

    for (let i = 0; i < maxChunks; i++) {
      const chunkPayload = { excludeAssets };
      if (nodeChunks[i]?.length > 0) chunkPayload.nodeids = nodeChunks[i];
      if (podChunks[i]?.length > 0) chunkPayload.podids = podChunks[i];
      if (assetChunks[i]?.length > 0) chunkPayload.assetids = assetChunks[i];

      if (chunkPayload.nodeids || chunkPayload.podids || chunkPayload.assetids) {
        try {
          const response = await API.post('download', chunkPayload);
          results.push(response.data || response);
        } catch (error) {
          // Continue processing other chunks for downloads
          console.error(`Download chunk ${i + 1}/${maxChunks} failed:`, error);
        }
      }
    }

    if (results.length === 0) {
      throw new Error('All download chunks failed');
    }

    return results.length === 1 ? results[0] : results;
  },

  exportThings: function(payload) {
    return API.post('exportarchive', payload).then(response => response.data);
  },

  downloadMediaNotes: function(payload) {
    return API.post('download/notes', payload, { responseType: 'blob' });
  },

  sendSupportTicket: function(payload) {
    const body = payload;
    return API.post('support/send', body);
  },

  sendFeatureRequest: function(payload) {
    const body = payload;
    return API.post('support/feature/send', body);
  },

  getLanguages: function() {
    const body = {};
    return API.get('languages', body);
  },

  createFreeTrial: function(payload) {
    const body = payload;
    return API.post('accountcreate', body);
  },

  salesmanCreatesTenant: function(payload) {
    const body = payload;
    return API.post('salesmancreatestenant', body);
  },

  resetTemporaryPassword: function() {
    const options = {};
    return API.patch(`temporary-password`, options);
  },
};
